import cross from '../assests/cross.svg';
import back from '../assests/back.svg';
import bulb from '../assests/bulb.svg';

export const icons = {
  cross,
  back,
  bulb,
};
